export const AMPLITUDE_LOCALHOST_PROXY_URL =
  'https://dev.partners.ada-music.com/2/httpapi';
